import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { DEFAULTS } from "../data/defaults";

const ContentContext = createContext(DEFAULTS);

const mergeContent = (server) => {
  const merged = {};
  for (const key of Object.keys(DEFAULTS)) {
    merged[key] = { ...DEFAULTS[key], ...(server?.[key] || {}) };
  }
  return merged;
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/content")
      .then(({ data }) => setContent(mergeContent(data)))
      .catch(() => setContent(DEFAULTS));
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
